import { Star, Quote, BadgeCheck } from "lucide-react";

function initials(name = "") {
  const parts = name.replace(/[^a-zA-Z ]/g, "").trim().split(" ").filter(Boolean);
  if (!parts.length) return "AP";
  return (parts[0][0] + (parts[parts.length - 1][0] || "")).toUpperCase();
}

export default function TestimonialCard({ testimonial }) {
  const t = testimonial;
  return (
    <figure
      data-testid={`testimonial-card-${t.id}`}
      className="flex h-full flex-col rounded-xl border border-slate-200 bg-white p-6 shadow-sm"
    >
      <div className="mb-3 flex items-center justify-between">
        <div className="flex gap-0.5 text-gold">
          {[...Array(5)].map((_, i) => <Star key={i} size={15} fill="#C5A059" strokeWidth={0} />)}
        </div>
        <Quote size={26} className="text-gold/25" />
      </div>
      <blockquote className="flex-1 text-sm leading-relaxed text-slate-700">"{t.quote}"</blockquote>
      <figcaption className="mt-5 flex items-center gap-3 border-t border-slate-100 pt-4">
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-navy font-serif text-sm font-bold text-gold">
          {t.photo_url ? (
            <img src={t.photo_url} alt="" className="h-full w-full rounded-full object-cover" />
          ) : (
            initials(t.display_name)
          )}
        </div>
        <div>
          <div className="flex items-center gap-1.5 text-sm font-semibold text-navy">
            {t.display_name}
            <BadgeCheck size={14} className="text-gold" />
          </div>
          <div className="text-xs text-slate-500">{t.service_category}</div>
        </div>
      </figcaption>
    </figure>
  );
}
